import {CheckIcon} from '@heroicons/react/20/solid';

import Switch from '../../../../components/Switch';
import Button from '../../../../components/Button';

import logo from '../../../../assets/images/logos-black-friday.png';

const includedFeatures = [
  'Sistema & Dashboard - WorkPodium',
  'App de registro de horas - TrackMyGuys',
  'Punch com localização via GPS',
  'Punch online e offline',
  'Gerenciamento de locais de trabalho',
  'Relatório de registro de horas',
  'Relatório de materiais utilizados',
  'Registro de horas e folha de pagamento',
  'Geofencing - Cercas virtuais',
  'Notificações push de chek-in/out',
  'Suporte via chat e e-mail',
];

const MonthlyPlan = () => (
  <>
    <p className="mt-6 flex items-baseline justify-center gap-x-2">
      <span
        className="text-3xl font-bold tracking-tight text-gray-400"
        style={{textDecoration: 'line-through'}}>
        $69.99
      </span>
    </p>
    <p className="flex items-baseline justify-center gap-x-2 text-center">
      <span className="text-5xl font-bold tracking-tight text-gray-900">
        $49.99
      </span>
      <span className="text-sm font-semibold leading-6 tracking-wide text-gray-600">
        USD
      </span>
    </p>
  </>
);

const YearlyPlan = () => (
  <>
    <p className="mt-6 flex items-baseline justify-center gap-x-2">
      <span
        className="text-3xl font-bold tracking-tight text-gray-400"
        style={{textDecoration: 'line-through'}}>
        $670
      </span>
    </p>
    <p className="flex items-baseline justify-center gap-x-2 text-center">
      <span className="text-5xl font-bold tracking-tight text-gray-900">
        $335.00
      </span>
      <span className="text-sm font-semibold leading-6 tracking-wide text-gray-600">
        USD
      </span>
    </p>
    <p className="text-xs leading-5 text-gray-600">yearly</p>
  </>
);

const Plan = ({plan, onChangePlan, onSelectPlan}) => (
  <div
    className="relative w-full bg-black border-t-4 border-b-4 border-yellow-500"
    style={{height: '100%', backgroundImage: 'url(bg-black-friday.jpg)'}}>
    <div className="pt-8 pb-24 sm:py-16">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mx-auto sm:text-center">
          <img
            className="mx-auto w-auto"
            style={{height: 230}}
            src={logo}
            alt="WorkPodium - Logo"
          />
        </div>

        <div className="mx-auto mt-4 max-w-2xl rounded-3xl ring-1 ring-gray-700 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h1 className="text-2xl font-extralight text-left lg:text-4xl text-yellow-500">
              Selecione <span className="font-bold">seu plano</span>
            </h1>
            {/* <p className="text-base leading-7 text-gray-400">Plan</p> */}
            <div className="mt-6 flex items-center gap-x-4">
              <h4 className="flex-none text-sm font-semibold leading-6 text-white">
                O que está incluso
              </h4>
              <div className="h-px flex-auto bg-gray-100" />
            </div>
            <ul className="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-white sm:grid-cols-2 sm:gap-6">
              {includedFeatures.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon
                    aria-hidden="true"
                    className="h-6 w-5 flex-none text-yellow-500"
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
            <div className="rounded-2xl bg-gray-50 py-10 border border-yellow-500 text-center ring-1 ring-inset ring-yellow-400 lg:flex lg:flex-col lg:justify-center lg:py-16">
              <div className="mx-auto max-w-xs px-8">
                <p className="flex items-center justify-center text-base font-semibold text-yellow-500">
                  <span className="text-sm text-gray-400 mr-2">Mês</span>{' '}
                  <Switch
                    checked={plan === 'yearly'}
                    onChange={() =>
                      onChangePlan(plan === 'yearly' ? 'monthly' : 'yearly')
                    }
                    extraClassName="mr-2"
                  />{' '}
                  anual 50% OFF
                </p>
                {plan === 'yearly' ? <YearlyPlan /> : <MonthlyPlan />}
                <Button
                  type="button"
                  className="mt-6 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                  onClick={() => onSelectPlan()}>
                  Comece agora
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Plan;
